import { useTheme } from '@emotion/react';
import { IconArrowUpRight, IconArrowDownRight, IconMinusCircleFilled } from '@hubble/icons/web';
import { Flex } from '../Flex/index.js';
import { Text } from '../Text/index.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Component = () => {
  console.error('Please use Delta.Item or Delta.Summary instead of Delta directly.');
  return {};
};
const getDeltaStatusColor = (status, colorScheme) => {
  const colorSchemeMap = {
    positive: colorScheme.dataVisualization.marketPositive,
    negative: colorScheme.dataVisualization.marketNegative,
    neutral: colorScheme.content.primary
  };
  return colorSchemeMap[status];
};
const StatusToItemIconMap = {
  positive: IconArrowUpRight,
  negative: IconArrowDownRight,
  neutral: undefined
};
const Item = ({
  label,
  status,
  size
}) => {
  const {
    colorScheme
  } = useTheme();
  const color = getDeltaStatusColor(status, colorScheme);
  const Icon = StatusToItemIconMap[status];
  return jsxs(Flex, {
    align: "center",
    children: [jsx(Text.Body, {
      size: size,
      color: color,
      children: label
    }), Icon && jsx(Icon, {
      color: color,
      size: size
    })]
  });
};
const StatusToSummaryIconMap = {
  positive: IconArrowUpRight,
  negative: IconArrowDownRight,
  neutral: IconMinusCircleFilled
};
const Summary = ({
  label,
  status,
  timeRange
}) => {
  const {
    colorScheme
  } = useTheme();
  const color = getDeltaStatusColor(status, colorScheme);
  const Icon = StatusToSummaryIconMap[status];
  return jsxs(Flex, {
    display: "inline-flex",
    children: [jsx(Icon, {
      color: color,
      size: "sm"
    }), jsx(Text.Body, {
      size: "sm",
      color: color,
      ml: 0.5,
      bold: true,
      children: label
    }), Boolean(timeRange) && jsx(Text.Body, {
      color: colorScheme.content.secondary,
      ml: 0.5,
      size: "sm",
      children: timeRange
    })]
  });
};
const Delta = Object.assign(Component, {
  Item,
  Summary
});

export { Delta };
